import { render, staticRenderFns } from "./ViewWithHeader.vue?vue&type=template&id=b7bd3fac&scoped=true&"
import script from "./ViewWithHeader.vue?vue&type=script&lang=js&"
export * from "./ViewWithHeader.vue?vue&type=script&lang=js&"
import style0 from "./ViewWithHeader.vue?vue&type=style&index=0&id=b7bd3fac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bd3fac",
  null
  
)

export default component.exports